import { render, staticRenderFns } from "./OVActionsIndex.vue?vue&type=template&id=68f56652&scoped=true&lang=pug"
import script from "./OVActionsIndex.vue?vue&type=script&lang=js"
export * from "./OVActionsIndex.vue?vue&type=script&lang=js"
import style0 from "./OVActionsIndex.vue?vue&type=style&index=0&id=68f56652&prod&lang=scss&scoped=true"
import style1 from "./OVActionsIndex.vue?vue&type=style&index=1&id=68f56652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f56652",
  null
  
)

export default component.exports